const gdn = {
    init: function() {
        // save old document.write
        var oldDocumentWrite = document.write

        // change document.write temporary
        document.write = function(node) {
            $("body").append(node)
        }

        // get script
        $.getScript("//www.googleadservices.com/pagead/conversion.js", {
            success: function() {
                // replace the temp document.write with the original version
                setTimeout(function() {
                    document.write = oldDocumentWrite
                }, 100)
            }
        });
    }
}

export default gdn;


// WEBPACK FOOTER //
// ./js/component/GDN/index.js